import { Dic } from '$utils'
const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '巡检项ID',
        prop: 'patrolItemGroupCode',
        type:'textarea',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        overHidden: true,
        span: 24
      }, {
        label: '巡检项名称',
        prop: 'patrolItemGroupName',
        type:'textarea',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        span: 24
      }, {
        label: '巡检子项',
        prop: 'patrolItemNames',
        type:'textarea',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        span: 24
      }
    ]
  }
}
export default tableOption
